module.exports = __webpack_public_path__ + "assets/img/sy-12.3717ec5a.png";